<template>
  <TarjetaDatos titulo="Conductor">
    <Campo2L :valor="conductor.nombre" />
    <Campo2L :valor="conductor.fecNacimiento | dateDDMMYYYY" etiqueta="Fecha Nacimiento" />
  </TarjetaDatos>
</template>

<script>
import emptyObj from "@/util/EmptyObject.js";
export default {
  props: {
    conductor: {
      type: Object,
      required: false,
      default: emptyObj
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
